import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import * as geolib from 'geolib';
import { useSelector } from 'react-redux';
import WebRoutes from '../../routes';
import CustomToast from '../../Components/Toast';
import { RidersLocationChannel } from '../../ActionCable/Channels';
import { ToastContainer, toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import './styles.css';

const App = () => {
  const user = useSelector((state) => state.userReducer.user);
  const [channelConnection, setChannelConnection] = useState(false);
  const locationCoordinatesRef = useRef();
  const [channel, setChannel] = useState();
  const [location, setLocation] = useState();

  useEffect(() => {
    location &&
      locationCoordinatesRef?.current &&
      channel &&
      channel.send({
        latitude: locationCoordinatesRef.current.latitude,
        longitude: locationCoordinatesRef.current.longitude,
      });
  }, [location?.latitude, location?.longitude]);

  useEffect(() => {
    if (channelConnection) {
      navigator?.geolocation?.getCurrentPosition(
        (position) => {
          locationCoordinatesRef.current = position.coords;
          setLocation(position.coords);
        },
        error,
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
      locationCoordinatesRef.current &&
        navigator?.geolocation?.watchPosition(success, error, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        });
    }
  }, [channelConnection]);

  useEffect(() => {
    setChannel(RidersLocationChannel);
    RidersLocationChannel.connected = () => {
      setChannelConnection(true);
    };
    RidersLocationChannel.disconnected = () => {
      setChannelConnection(false);
    };
  }, [user]);

  function success(position) {
    const difference = geolib.getPreciseDistance(
      {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      },
      {
        latitude: locationCoordinatesRef?.current?.latitude,
        longitude: locationCoordinatesRef?.current?.longitude,
      },
      0.01
    );
    if (difference > 5.0) {
      locationCoordinatesRef.current = position.coords;
      setLocation(position.coords);
    }
  }

  function error(err) {
    if (user && channelConnection) {
      switch (err.code) {
        case err.PERMISSION_DENIED:
          toast(
            <CustomToast
              severity="warning"
              message="Location Services are off"
            />,
            { closeButton: false }
          );
          break;
        default:
          break;
      }
    }
  }
  return (
    <>
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <WebRoutes locationCoordinates={locationCoordinatesRef?.current} />
      </Box>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={1}
      />
    </>
  );
};

export default App;
